<template>
  <div id="nav-todo">
    <b-nav>
      <b-nav-item v-on:click="logOut">Logout</b-nav-item>
      <b-nav-item v-on:click="todoBin">휴지통</b-nav-item>
      <b-nav-item v-on:click="todoList">할일목록</b-nav-item>
      <div class="info"><strong>{{ name }}</strong>님</div>
    </b-nav>
  </div>
</template>

<script>
export default {
  methods:{
    logOut:function(){
      this.$store.dispatch('logOut');
    },
    todoBin:function(){
      this.$router.push('bin');
    },
    todoList:function(){
      this.$router.push('todo')
    }, 
    TodoCamera:function(){
      this.$router.push('camera');
    }
  },
  computed:{
    name(){
      return this.$store.getters.getAuth.name;
    }
  }
}
</script>

<style scoped>
  #nav-todo{
    background: #00BFFF;
    color: #FFFFFF;
  }
  #nav-todo > b-nav-item{
    color: black;
  }
  .info{
    padding-top: 1%;
    text-align: right;
    padding-right: 5%;
    margin-left: auto;
    color: #F0FFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoNav.vue